import _ from 'lodash';

export default {
    methods: {
        sortScenarios(scenarios){
            //Alphabetically sort by default
            return _.sortBy(scenarios, 'name');
        }
    }
};